import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerDotted16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDividerDotted16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.046 2.007a1 1 0 0 0-1 1v1.5a.5.5 0 1 1-1 0v-1.5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.5a.5.5 0 0 1-1 0v-1.5a1 1 0 0 0-1-1zM4 14a1 1 0 0 1-1-1v-1.5a.5.5 0 0 0-1 0V13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V13a1 1 0 0 1-1 1zm4-5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M2.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m7.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerDotted16);
